"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleRoutes = void 0;
var ModuleRoutes;
(function (ModuleRoutes) {
    ModuleRoutes["BasePrefix"] = "modules";
    ModuleRoutes["All"] = "all";
    ModuleRoutes["Modules"] = "modules";
    ModuleRoutes["Details"] = "details";
})(ModuleRoutes = exports.ModuleRoutes || (exports.ModuleRoutes = {}));
